import { useLocation } from 'react-router-dom'

import { AllProductUpdateModulesDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { usePaginatedQuery } from 'modules/core/hooks/usePaginatedQuery'

import { getDatoLocale } from 'modules/onboarding/lib/datoLocale'

export type GetProductUpdateModulesProps = {
  alreadyReleased?: boolean
  moduleSlug?: string
  locale?: string
}

export const useGetProductUpdateModules = (variables: GetProductUpdateModulesProps) => {
  const {
    access: { locale: accessLocale },
  } = useCurrentSession()
  const { search } = useLocation()
  const locale = getDatoLocale(accessLocale)
  const preview = new URLSearchParams(search).get('preview') === 'true'
  const {
    nodes: modules,
    loading,
    controls,
  } = usePaginatedQuery(AllProductUpdateModulesDocument, {
    variables: { ...variables, preview, locale },
    extractConnection: (e) => e.productUpdates.updateModulesConnection,
  })

  return {
    loading,
    modules,
    controls,
  }
}
